import { DEVELOPMENT_ENV } from 'constants/general';
import * as graphql from 'generated/graphql';
import { createContext, useContext } from 'react';

const Context = createContext<Pick<graphql.Workspace, 'id'>>({ id: '' });

export const WorkspaceProvider = Context.Provider;

// eslint-disable-next-line import/prefer-default-export
export const useWorkspace = (): Pick<graphql.Workspace, 'id'> => {
	return useContext(Context);
};

// eslint-disable-next-line import/prefer-default-export
export const useWorkspaceAlias = (): string => {
	// eslint-disable-next-line no-restricted-globals
	return process.env.NODE_ENV === DEVELOPMENT_ENV
		? 'testenv'
		: window.location.hostname.endsWith('.dev')
		? 'testenv'
		: window.location.hostname.split('.')[0];
};
